import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { gettext } from 'utils/text';
import { ORDERING_CHOICES, search, sort } from 'ducks/arena';
import { FilterChoiceShape } from 'utils/shapes';
import ArenaBase from 'components/ArenaBase';
import reverseUrl from '../../utils/urls';

const mapStateToProps = (state) => ({
    query: state.query,
    ordering: state.ordering,
    filterChoices: state.choices,
    selectedFilterKey: state.filterKey,
});

const mapDispatchToProps = (dispatch) => ({
    search: (query) => dispatch(search(query)),
    sort: (value) => dispatch(sort(value)),
});

@connect(mapStateToProps, mapDispatchToProps)
class ArenaHeader extends ArenaBase {
    static propTypes = {
        query: PropTypes.string.isRequired,
        ordering: PropTypes.string.isRequired,
        search: PropTypes.func.isRequired,
        sort: PropTypes.func.isRequired,
        filterChoices: PropTypes.arrayOf(FilterChoiceShape).isRequired,
        selectedFilterKey: PropTypes.string.isRequired,
    };

    state = {
        query: '',
    };

    render() {
        const buttonUrl = reverseUrl('trafo_arena_media_add');
        const buttonText = gettext('Upload');
        return (
            <div className="arena__header">
                <div className="arena__header__title">
                    <h2>{gettext('Explore works')}</h2>
                </div>
                {this.renderSort(ORDERING_CHOICES.choices)}
                {this.renderSearch()}
                <a className="btn btn-primary mb-0 border-0" href={buttonUrl}>
                    {buttonText}
                </a>
            </div>
        );
    }
}

export default ArenaHeader;



// WEBPACK FOOTER //
// ./src/components/arena/ArenaHeader.js